import React from 'react';
import Edit from 'containers/rest/Edit';
import Form from '../components/Form';

const EventsEdit = props => (
  <Edit {...props} resource="events">
    <Form />
  </Edit>
);

EventsEdit.propTypes = {};

export default EventsEdit;
